import Model from "~/models/_Model";
import Course from "./Course";

export default class EspCourseRequest extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courseplanner";
  }

  // Set the resource route of the model
  resource() {
    return "esp-requests";
  }

  relations() {
    return {
      course_info: Course,
    };
  }

  // Computed Attributes
  get display_request_type() {
    switch (this.REQUEST_TYPE) {
      case "R":
        return "Regular Request";
      case "C":
        return "Course Alternate";
      case "S":
        return "Student Alternate";
    }
    return `Unknown Request Type: ${this.REQUEST_TYPE}`;
  }

  get display_course_description() {
    if (!this.course_info) {
      return this.COURSE;
    }
    return `${this.COURSE}: ${this.course_info.DESCRIPTION_CLEAN}`;
  }

  get display_alt_course_description() {
    if (!this.ALT_TO_REQUEST) {
      return null;
    }
    if (!this.alt_course_info) {
      return `${this.ALT_TO_REQUEST} (Priority: ${this.ALTERNATE_SEQUENCE})`;
    }
    return `${this.ALT_TO_REQUEST}: ${this.alt_course_info.DESCRIPTION_CLEAN} (Priority: ${this.ALTERNATE_SEQUENCE})`;
  }

  get display_course_marking_periods() {
    if (!this.marking_periods || this.marking_periods.length == 0) {
      return "Any";
    }

    return this.marking_periods.map((i) => i.MARKING_PERIOD.trim()).join(", ");
  }
}
